import React from 'react';
import '../styles/Spinner.scss';

// Loading indicator: a turning ring plus an optional label, announced to screen readers.
const Spinner = ({ label, size = 'md' }) => (
  <span className={`spinner spinner--${size}`} role="status" aria-live="polite">
    <span className="spinner-ring" aria-hidden="true" />
    {label && <span className="spinner-label">{label}</span>}
  </span>
);

export default Spinner;
